/**
 * @ngdoc directive
 * @name lspEmailValidator.directive:lspEmailDirective
 * @description
 * # lspEmail
 */

function lspEmail() {
  const EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return {
    require: ['ngModel'],
    restrict: 'A',
    link: (scope, elm, attrs, ctrl) => {
      // only apply the validator if ngModel is present
      if (ctrl[0]) {
        // this will overwrite the default Angular email validator
        ctrl[0].$validators.email = (modelValue) => ctrl[0].$isEmpty(modelValue) || EMAIL_REGEXP.test(modelValue);
      }
    },
  };
}

export default lspEmail;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-validators/lsp-email-validator/lsp-email-directive.js